import script from "./EntryPageBulkDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryPageBulkDialog.vue?vue&type=script&setup=true&lang=js"

import "./EntryPageBulkDialog.vue?vue&type=style&index=0&id=4dcf7d74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcf7d74"]])

export default __exports__